export const roundValue = (value: number, descimals: number = 2) =>
  Math.round((value + Number.EPSILON) * 10 ** descimals) / 10 ** descimals;
